<template>
  <div id="employees">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container grid-list-xl fluid>
      <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{'menu._Employees_'|translate}}: {{this.employees.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addNewEmployee">
        {{'emp._new_emp_'|translate}}
      </v-btn>
    <download-excel
	class   = "btn btn-default"
	:data   = "employees"
	:fields = "json_fields"
  type    = "csv"
	name    = "Employees_.csv">
  <v-btn type="button" class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}}
</v-btn> 
</download-excel> 
    </v-toolbar>

        <v-layout row wrap>  
    
          <v-flex lg3 sm12 v-for="(item,index) in employees" :key=" 'bottom-nav' + index">
            
            <name-card
              bottom-nav
              v-bind="item"
            >
            </name-card>
          </v-flex>    
          <!-- <v-flex sm12>
            <h4>Contact Card</h4>  
          </v-flex>      
          <v-flex lg4 sm12>
            <profile-card></profile-card>
          </v-flex> -->
        </v-layout>
      </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import NameCard from '@/components/widgets/card/NameCard';
// import ProfileCard from '@/components/widgets/card/ProfileCard';
export default {
  components: {
    NameCard
    // ProfileCard
  },
  data () {
    return {
      loading: true,
      employeeId: '',
      employeeNumber: '',
      createdBy: '',
      createdById: '',
      employee_id: '',
      
      json_fields: {
        'employee Id': 'id',
         'Nom et Prenom':'fullName',
        'Prenom': 'firstName',
         "Nom":"lastName",
          'Telephone': 'phone',
           'Email': 'email',
            'Role': 'role',
      },
    };
  },
  created () {
      if(firebase.auth().currentUser) {
        this.createdById = firebase.auth().currentUser.uid
        this.createdBy = firebase.auth().currentUser.displayName
        if(!this.createdBy) {
          this.createdBy = firebase.auth().currentUser.email
        }
      }
  },
  computed: {
    employees () {
     
      let employees = this.$store.getters.employees;
      
      this.loading = false;
      return employees;
    }
  }, 
  watch: {
    employees () {
      let employees = this.$store.getters.employees;    
      return employees;
    }
  }, 
  methods: {
    addNewEmployee () {
      let newMemberRef = db.collection('Employees').doc();
      let refAccess = newMemberRef.id;
      this.employeeId = refAccess;
      this.employee_id = refAccess;
      this.employeeNumber = refAccess.substring(0, 10);
      newMemberRef.set({
        employeeNumber: this.employeeNumber,
        imageUrl: '/static/avatar/avatar.png',
        lowerEmployeeNumber: this.employeeNumber.toLowerCase(),
        createdDate: new Date(),
        createdBy: this.createdBy,
        createdById: this.createdById,
      })
        .then(() => {
          this.fetchEmployee()
        });
    }, 
  fetchEmployee () {
    db.collection('Employees').doc(this.employee_id)
    .get()
    .then(doc => {
        const data = {
          id: doc.id,
          firstName: doc.data().firstName,
          lastName: doc.data().lastName,
          posteName: doc.data().posteName,
          phone: ""+doc.data().phone,
          email: doc.data().email,
          role: doc.data().accessLevel,
          avatar: {
            src: doc.data().imageUrl,
            size: 36
          }
        };
        if (data.role === 'Admin') {
          data.cardBgImage = '/static/bg/15.jpg';
        }
        this.$store.commit('currentEmployee', data);
          this.$router.push('/modifiers/employeeprofile');
      this.loading = false;
    });
  }
}
};
</script>


// WEBPACK FOOTER //
// src/pages/Employees.vue